"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "grosseto": {
    "3af0ff8a": [{
      "hkey": "c0f5cd0e",
      "slug": "istia-d-ombrone-casalecci",
      "name": "Istia d'Ombrone-Casalecci",
      "primary": true,
      "skipSearch": false
    }],
    "istia-d-ombrone": [{
      "hkey": "c0f5cd0e",
      "slug": "istia-d-ombrone-casalecci",
      "name": "Istia d'Ombrone-Casalecci",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4e4ed67b": [{
      "hkey": "e2e724bd",
      "slug": "rispescia",
      "name": "Rispescia",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-di-rispescia": [{
      "hkey": "e2e724bd",
      "slug": "rispescia",
      "name": "Rispescia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;